import { ThunkAction, AnyAction, Store, ThunkDispatch, Action, ListenerEffectAPI, createAsyncThunk } from "@reduxjs/toolkit";
import { AwClientInterface } from "../ports/aw-client.interface";
import { EtlDataState } from "../slices/etlData/slice/etlData.types";
import { FormStepData } from "../slices/formStep/slice/formStep.type";
import { LocalStorageInterface } from "../ports/local-storage.interface";
import { EtlClientInterface } from "../ports/etl-client.interface";
import { AuthState } from "../slices/auth/slice/auth.types";
import { NavigationServiceInterface } from "../ports/navigation-service.interface";
import { NavigationState } from "../slices/navigation/slice/navigation.type";
import { BaseQueryFn, EndpointBuilder } from "@reduxjs/toolkit/query";
import { apiSlice } from "./rtk-instance";

/**
 * 	Merge all initial states of all slices in one global state
 */
export type RootState = {
	etlData: EtlDataState
	formStep: FormStepData
	auth: AuthState
	navigation: NavigationState
	etlApi: ReturnType<typeof apiSlice.reducer>
};

/**
 * Merge all secondary adapters interfaces in one global dependencies
 */
export interface Dependencies {
	etlClient: EtlClientInterface
	awClient: AwClientInterface
	localStorage: LocalStorageInterface
	navigationService: NavigationServiceInterface
}

/**
 * Type pour les use cases de type appthunk
 */
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, Dependencies, AnyAction>;

/**
 * Type pour le store lui-même et sa fonction dispatch
 */
export type ReduxStore = Store<RootState> & {
	dispatch: ThunkDispatch<RootState, Dependencies, Action>
};

/**
 * type de la fonction dispatch, tel que dans les React :
 * const dispatch = useDispatch<AppDispatch>()
 */
export type AppDispatch = ThunkDispatch<RootState, Dependencies, Action>;

/**
 * Type pour les actions asynchrones, tel que dans les use case :
 *  const useCase = createAsyncThunk<Response, Request, ThunkApi>("logout", async (data, { dispatch, extra }) => {})
 */
export interface ThunkApi {
	dispatch: AppDispatch
	getState: () => RootState
	extra: Dependencies
	state: RootState
}

export type ListenerApi = ListenerEffectAPI<RootState, AppDispatch>;

export const createAppAsyncThunk = createAsyncThunk.withTypes<ThunkApi>();

export type EndpointAppBuilder = EndpointBuilder<BaseQueryFn, string, string>;
